import React from 'react';
import { ArrowLeft, Share2 } from 'lucide-react';
import * as v5 from '../../styles/v5.styles';
import { gradients } from '../../styles/v5.styles';

/**
 * Tela 2 — Destino
 *
 * Entry point: NOME_DESTINO. (serif, uppercase, substantivo próprio)
 * Body: narrativa do destino (Raleway Light, prata)
 * CTA: "Conhecer o destino" (verbo + objeto concreto)
 * Meta: "Passo 2 · Destino" (22% opacidade)
 */

const DEFAULT_NARRATIVE =
  'A cidade que nunca para de surpreender. É onde a arte pulsa em cada esquina, onde a gastronomia transforma cada refeição em experiência única e memorável.';

export default function StorytellingPromise({
  quote,
  narratives = {},
  onContinue,
  onBack,
  onShare,
}) {
  const defaultImage =
    'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80';
  const backgroundImage = quote?.destination_image_url_2 || defaultImage;
  const destination = quote?.destination || 'Destino';
  const promise = narratives?.destination_promise || {};
  const bodyText = promise?.support_text || DEFAULT_NARRATIVE;

  return (
    <div
      style={{
        ...v5.screenBase,
        background: gradients.screen2.base,
      }}
    >
      {/* Background image */}
      <div
        style={{
          ...v5.screenBg,
          height: gradients.screen2.bgHeight,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div style={v5.screenBgOverlay} />
      </div>

      {/* Top bar */}
      <div style={v5.topBar}>
        <button onClick={onBack} style={v5.iconBtn}>
          <ArrowLeft size={18} />
        </button>
        <button onClick={onShare} style={v5.iconBtn}>
          <Share2 size={18} />
        </button>
      </div>

      {/* Content: 3 níveis */}
      <div style={v5.screenContent}>
        <div style={v5.screenMeta}>Passo 2 · Destino</div>
        <h1 style={v5.entryPoint}>{destination}.</h1>
        <p style={v5.screenBody}>{bodyText}</p>

        {/* Step dots */}
        <div style={v5.stepDots}>
          <div style={v5.stepDot} />
          <div style={v5.stepDotActive} />
          <div style={v5.stepDot} />
          <div style={v5.stepDot} />
          <div style={v5.stepDot} />
          <div style={v5.stepDot} />
          <div style={v5.stepDot} />
        </div>

        <button onClick={onContinue} style={v5.ctaButton}>
          Conhecer o destino
        </button>
      </div>
    </div>
  );
}
